export default "__VITE_ASSET__B427Rtjh__"